import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './i18n/config';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache for 30s so route switches (e.g. /entries ↔ /entries/open)
      // don't re-fetch stats / lenders / entries from scratch every time.
      // Lookup itself is a useMutation, so it's always fresh regardless.
      // Pages that need stricter freshness can override per-query.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// A focused <input type="number"> steps its value on every wheel / trackpad
// scroll over it — scrolling the page after typing "9000" silently turned
// it into 8926 (Frank, 2026-09-28, also on prod). Drop focus before the
// wheel reaches the field: the page scrolls, the amount stays as typed.
document.addEventListener(
  'wheel',
  (event) => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === 'number' && event.target === el) {
      el.blur();
    }
  },
  { passive: true },
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
